/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  ReactElement,
  useEffect,
  useMemo,
  useState,
  useRef,
  useCallback
} from 'react';
import { navigate } from 'gatsby';
import { OrderSummary as OrderSummaryModule } from '@common-modules/shopping-cart';
import TermsAndConditions from '../TermsAndConditions';
import { getShoppingCartDataModel } from '../../helpers/cart';
import { useDispatch, useSelector } from 'react-redux';
import { KeyValue } from '../../types/common.types';
import {
  flattenNodes,
  getAccountBillingInfo,
  dataLayerPush,
  getAemConfigs,
  formatServiceNumberForPxAddons
} from '../../helpers/common';
import {
  Grid,
  Stepper,
  Row,
  Column,
  Spacing,
  SkeletonLoader,
  useDevice
} from '@dls/web';
import { ORDER } from '../../constants';
import {
  getBillingAddressInfo,
  getESimDeliveryOptions,
  getFreebieStockData,
  getPaymentIntentParams,
  getPaymentOptions,
  getPaymentRequestParams,
  getPersonalInfo,
  getPromoResult,
  getShowBillingChangeState,
  getUserContactInfo,
  getYuuMemberInfo,
  isZeroUpfrontCharges,
  validatePaymentRequest,
  updatePxAddonAndProductsListPricing
} from './helper';
import {
  authActions,
  orderSummaryActions,
  orderActions,
  userActions,
  api
} from '@detox/actions';
import CHECKOUT_CONSTANTS from '../../constants/checkout';
import ORDER_CONSTANTS from '../../constants/order';
import CONSTANTS from '../../constants/common';
import { ORDER_SUMMARY_CONSTANTS } from '../../constants/ordersummary';
import { dppLink } from '../../config/links';
import {
  ActionTypes,
  FormattedPaymentOption,
  OrderSummaryDataModel,
  PaymentType,
  PromoCodeEmpty,
  PromoCodeInfo,
  PromoCodeOptions
} from '../../types/orderSummary.types';
import { navigation } from '../../middlewares/navigation-constants';
import { SkeletonWithSideBar } from '../SkeletonLoader';
import { TObject } from '../../types/registrationCheckout';
import Tnc from './Tnc';
import { ACTION_TYPES } from '../../constants/actions';
import { useInit } from '../../hooks/useInit';
import useUser from '../../hooks/useUser';

import LoadingOverlayComponent from '../LoadingOverlay';
import { useErrorHandler } from '../../hooks/useErrorHandler';
import { resetPromoData } from '../../reducers/fulfillment/delivery';
import { getFulfilmentProductsList } from '../Fulfilment/helpers';
import { isMobileShareOrSimOnlyPlan } from '../../helpers/shoppingCartHelper';
import { trans as t } from '../../helpers/localisation';
import { OrderSummaryState } from '../../reducers/orderSummary';
import createDescription from '../../helpers/create-description';
import { useFlowCheck } from '../../hooks/useFlowCheck/useFlowCheck';
import isFeatureFlagEnabled from '../../helpers/feature-flags';
import { YUU_MEMBERSHIP } from '../../types/featureFlag.types';
import { AEM_CONFIG_KEYS, CONFIGS } from '../../config/common';
import ChangeContactDetails from './ChangeContactDetails';
import { useAmendedTab } from '../../hooks/useAmendedTab/useAmendedTab';
import { SkipStepModal } from './MissingStepModal';
import usePaymentRedirection from '../../hooks/usePaymentRedirection';
import { ACTION_TYPES as MODULE_ACTION_TYPES } from '@detox/actions';
import {
  CISMyInfoUserData,
  CustomerInfoResponse
} from '../../types/checkout.types';
import { getFormattedDate, isInCompleteSingpassData } from '../Checkout/helper';
import { getOrderSummaryDataLayer } from '../../helpers/dataLayerHelpers';
import {
  getIfCISMyInfoFlow,
  getIfESimOrder,
  getIsEKYCFlow,
  getChangeCISEKYCFlow,
  getOrderHashedFaId,
  getHasedUserSubServiceID,
  getGTMOrderType
} from '../../selectors';
import { useBrowserBack } from '../../hooks/useBrowserBack/useBrowserBack';
import { setThankYouPageData } from '../../reducers/payment';
const { getUserInformation } = userActions;

type PropTypes = {
  data: TObject;
};

const eShopPxAddonsCalculatePayable =
  api.onlineApi.eShopPxAddonsCalculatePayable;

export const OrderSummary = (props: PropTypes): ReactElement => {
  const totalCheckOutPrice = useRef<number>();
  const totalOneTimePrice = useRef<number>();
  const discountAddons = useRef<number>(0);
  const [dataModel, setDataModel] = useState<
    OrderSummaryDataModel | KeyValue
  >();
  const [tncModal, setTncModal] = useState(false);
  const [showMissingStepModal, setShowMissingStepModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  const {
    allPlan,
    allAddonMobileLob,
    allAspireBillingOffer,
    config,
    membership,
    allPaymentMethod,
    allVariableConfig
  } = props.data;
  const variableConfigs = flattenNodes(allVariableConfig) || [];
  const [
    enableChangeCisMyInfo = '',
    pxBccAddonsMapper = ''
  ] = getAemConfigs(variableConfigs, [
    AEM_CONFIG_KEYS.DETOX_CIS_MYINFO_CHANGE_SKIP_DOC_UPLOAD,
    AEM_CONFIG_KEYS.DETOX_PX_BCC_ADDONS_MAPPER
  ]);

  const paymentOptions = flattenNodes(allPaymentMethod);
  const {
    fulfilmentState,
    product,
    cart,
    checkout,
    userInformation,
    productOrder,
    stepperTitles,
    user,
    contactAddress,
    orderSummary,
    selectedPlan,
    billingAccountDetails,
    auth,
    cisUserInfo,
    accessories,
    order,
    iphone,
    thirdParty,
    customerMyInfo,
    cisInformation,
    isESimOrder,
    userCISMyInfoAvailable,
    isEkycFlow,
    changeCISMyInfoFlow,
    promotions,
    hasedUserSubServiceID,
    hashedFaId,
    orderType,
    addons
  } = useSelector((state: KeyValue) => ({
    promotions: state.promotions,
    product: state.product,
    cart: state.cart,
    accessories: state.accessory,
    checkout: state.checkout,
    fulfilmentState: state.fulfillment,
    userInformation: state.user?.information,
    productOrder: state.order?.productOrder || {},
    selectedPlan: state.plan?.selectedPlan,
    stepperTitles: state.checkout?.stepperTitles,
    user: state.user,
    contactAddress:
      state.fulfillment?.delivery?.deliveryDetails?.contactAddress,
    orderSummary: state.orderSummary as OrderSummaryState,
    billingAccountDetails:
      state.fulfillment?.delivery?.deliveryDetails?.billingAccountDetails,
    auth: state.auth,
    cisUserInfo: state.user?.cis?.information,
    order: state.order,
    iphone: state.iphone,
    thirdParty: state?.thirdParty,
    customerMyInfo: state?.customerMyInfo,
    cisInformation: state.user?.cis?.information,
    isESimOrder: getIfESimOrder(state),
    userCISMyInfoAvailable: getIfCISMyInfoFlow(state),
    isEkycFlow: getIsEKYCFlow(state),
    changeCISMyInfoFlow: getChangeCISEKYCFlow(state, enableChangeCisMyInfo),
    hasedUserSubServiceID: getHasedUserSubServiceID(state),
    hashedFaId: getOrderHashedFaId(state),
    orderType: getGTMOrderType(state),
    addons: state.addons
  }));
  const dispatch = useDispatch();
  useBrowserBack();
  useFlowCheck({
    flowData: [
      cart?.cartOrder,
      checkout.stepperTitles?.includes(t('CO_NN_STEPPER_TWO'))
        ? fulfilmentState?.delivery?.selectedDeliveryMode
        : checkout.checkoutFlow
    ]
  });
  const { renderError } = useErrorHandler({
    states: [auth, user, orderSummary]
  });

  const { selectedProduct } = product;
  const { cartOrder } = cart;
  const { selectedAccessories } = accessories;
  const { deliveryOptions } = fulfilmentState.delivery;
  const myInfoCustomerData: CustomerInfoResponse =
    customerMyInfo?.customerInfoResponse?.ImplCustomerInfoResponse;
  const isCompleteMyInfoData = isInCompleteSingpassData(myInfoCustomerData);
  const isShowOverlayLoading = orderSummary?.isLoading;
  const { updatedContact } = orderSummary;
  const userCISMyInfo: CISMyInfoUserData = cisInformation?.cusMyInfo;
  const promoCodeInfo: PromoCodeInfo = fulfilmentState.delivery?.promoCodeInfo;
  const plans = useMemo(() => flattenNodes(allPlan), [allPlan]);
  const isNewNewFlow =
    checkout.checkoutFlow === CHECKOUT_CONSTANTS.CHECKOUT_NEW_NEW_CUSTOMER;
  const hideBillingChange = getShowBillingChangeState({
    isESimOrder,
    isNewNewFlow,
    userCISMyInfoAvailable,
    isCompleteMyInfoData
  });
  const isYuuEnabled =
    !promotions?.specialPromo &&
    isFeatureFlagEnabled(YUU_MEMBERSHIP) &&
    [ORDER.TYPE.NEW, ORDER.TYPE.PORTIN, ORDER.TYPE.MS_NEW].includes(
      order?.productOrder?.type
    ) &&
    !cisUserInfo;
  const pxAddonsCalculationId = useRef<string>('');

  useUser();

  useEffect(() => {
    // if user tries to go back from thank-you page to order-summary
    // this will check and navigate to home page
    if (!order?.productOrder) {
      navigate('/', { replace: true });
    }
  }, [productOrder]);

  /**
   * Retrieves the FA (Financial Account) ID from the account billing information
   * if the product order type is not `RECON`. The FA ID is only returned if it is not masked
   *
   * @returns An object containing the `faId` if available and valid; otherwise, an empty object.
   */
  const getFaID = () => {
    const faId = userInformation?.clientContext?.financialAccounts?.[0]?.faId;
    if (
      productOrder.type !== ORDER.TYPE.RECON &&
      faId?.toString()?.length > 6
    ) {
      if (faId && /^\d+$/.test(faId)) {
        return { faId };
      }
    }
    return {};
  };

  const pxAddonsCalculatePayable = async () => {
    const updatedAddonsCalculatePayload = addons?.pxAddons?.map(item => ({
      id: item.variant.id,
      productId: item.id,
      action: 'add',
      quantity: 1,
      recurrable: item.variant.recurrable,
      items: []
    }));

    try {
      const response = await eShopPxAddonsCalculatePayable({
        serviceNumber: formatServiceNumberForPxAddons(
          cart?.order?.mobile?.serviceId
        ),
        addonsList: updatedAddonsCalculatePayload,
        ...getFaID()
      });
      let finalPxAddons = addons?.pxAddons;
      if (response?.error) {
        throw new Error(response.error?.message ?? '');
      } else {
        const pricingInfo = response?.body?.data;
        pxAddonsCalculationId.current = pricingInfo?.id || '';
        const {
          updatedPxAddons,
          updatedProductsList
        } = updatePxAddonAndProductsListPricing(
          addons?.pxAddons,
          cartOrder.monthlyBills,
          pricingInfo
        );

        dispatch({
          type: ACTION_TYPES.ADDONS.PX_ADDON_CART_UPDATE,
          payload: {
            monthlyBills: updatedProductsList,
            pxNewAddons: updatedPxAddons
          }
        });
        dispatch({
          type: ACTION_TYPES.ADDONS.PX_ADDONS_UPDATE,
          payload: { pxAddons: updatedPxAddons }
        });
        finalPxAddons = updatedPxAddons;
      }
      return finalPxAddons;
    } catch (e) {
      dispatch({
        type: ACTION_TYPES.ADDONS.PX_ADDONS_RESET,
        payload: {
          pxAddons: null,
          pxExistingAddons: null,
          productOrderId: null
        }
      });
      return [];
    }
  };

  useEffect(() => {
    if (!auth?.headers || !Object.keys(auth.headers)?.length) {
      dispatch(authActions.getOnePassHeaders());
    }
    dispatch({ type: ACTION_TYPES.ORDER_SUMMARY.CLEAR_PAYMENT_INTENT });

    dataLayerPush(
      getOrderSummaryDataLayer({
        selectedPlan,
        selectedVariant: selectedProduct,
        accessories: accessories?.selectedAccessories,
        location: window.location,
        order: productOrder
      }),
      true
    );
  }, []);

  const { renderAmendedErrorPopup, tabIsAmended } = useAmendedTab();
  const isBuyingWithoutDevice =
    isMobileShareOrSimOnlyPlan(selectedPlan) && !cartOrder?.device;
  const { productsList } = getFulfilmentProductsList({
    cartOrder,
    selectedProduct,
    fulfillment: fulfilmentState,
    selectedAccessories,
    isBuyingWithoutDevice,
    priceNeeded: true,
    needFreebies: false,
    nounderline: false
  });

  const getOrderSummaryPayload = finalPxAddons => {
    return {
      customerId: productOrder?.service?.customerId || getCustomerId(),
      productOrderId: productOrder?.productOrderId,
      productOrderReferenceNumber: productOrder?.productOrderReferenceNumber,
      technicalVasIds: allAddonMobileLob?.edges.map(edge => edge.node.addonId),
      aspireBillingOffers: allAspireBillingOffer?.edges.map(
        edge => edge.node.boId
      ),
      pxAddons: finalPxAddons,
      pxExistingAddons: addons.pxExistingAddons,
      pxBccAddonsMapper
    };
  };

  const getOrderSummaryData = async () => {
    //calculate Final Payable for Px Addons only when pxAddons is present
    const finalPxAddons = addons?.pxAddons?.length
      ? await pxAddonsCalculatePayable()
      : [];
    dispatch(
      orderSummaryActions.getOrderSummaryData(
        getOrderSummaryPayload(finalPxAddons)
      )
    );
  };

  useEffect(() => {
    if (userInformation?.clientContext || userInformation?.anonymousContactId) {
      getOrderSummaryData();
    }
  }, [userInformation?.clientContext, userInformation?.anonymousContactId]);

  const getOrderSummaryConfigData = () => {
    const paymentOptions = _getPaymentOptions();
    return {
      isZeroUpfront: isZeroUpfrontCharges(orderSummary?.quoteData),
      ignorePaymentMethodPopup: paymentOptions.length === 1,
      defaultPaymentType:
        paymentOptions[0]?.type || ORDER_CONSTANTS.PAYMENT_TYPES.ONLINE
    };
  };

  useEffect(() => {
    if (!fulfilmentState.delivery?.hasConfirmedFulfilment) {
      setShowMissingStepModal(true);
    }
  }, []);
  useEffect(() => {
    const orderSummaryData = getOrderSummaryConfigData();
    if (promoCodeInfo) {
      const { promoCodeResult } = getPromoResult(promoCodeInfo, orderSummary);
      setDataModel(prev => ({
        ...prev,
        promoCodeResult,
        orderSummaryData
      }));

      if (promoCodeInfo.promoCode === PromoCodeEmpty.EMPTY) {
        dispatch(resetPromoData());
      }
    } else {
      dispatch(resetPromoData());
      setDataModel(prev => ({
        ...prev,
        promoCodeResult: {
          errorMessage: undefined,
          appliedPromoCode: '',
          promoText: undefined,
          isSuccess: false,
          keepPromoOpen: false,
          disabled: false,
          isLoading: false
        },
        orderSummaryData
      }));
    }

    const totalPriceFromSummary = orderSummary?.order?.totalCheckOutPrice;
    const totalOneTimePriceFromSummary = orderSummary?.order?.totalOneTimePrice;
    const discountedAddons = orderSummary?.order?.discountAddons?.length || 0;

    if (
      totalCheckOutPrice.current !== totalPriceFromSummary ||
      totalOneTimePrice.current !== totalOneTimePriceFromSummary ||
      discountAddons.current !== discountedAddons
    ) {
      init();
      totalCheckOutPrice.current = totalPriceFromSummary;
      totalOneTimePrice.current = totalOneTimePriceFromSummary;
      discountAddons.current = discountedAddons;
    }
  }, [promoCodeInfo, orderSummary]);

  useEffect(() => {
    init();
  }, [orderSummary?.quoteData]);

  useEffect(() => {
    if (updatedContact) {
      init();
    }
  }, [updatedContact]);

  useInit(() => {
    init();
  }, [orderSummary?.order]);

  useInit(() => {
    init();
  }, [userInformation, orderSummary?.order?.serviceId]);

  useEffect(() => {
    fetchContract();
  }, [orderSummary.quoteFetched]);

  useEffect(() => {
    // hashed user sub service id and fa ID for GTM, for non new-new flow
    // orderType in this is true only when order is recon or existing new
    if (!isNewNewFlow && orderType && hasedUserSubServiceID && hashedFaId) {
      dispatch({
        type: ACTION_TYPES.GTM_SEND_EVENTS.SEND_SERVICE_LINE,
        payload: {
          platform_user_id: hasedUserSubServiceID,
          platform_user_id_type: orderType,
          said: hashedFaId
        }
      });
    }
  }, [hasedUserSubServiceID, hashedFaId, orderType]);

  usePaymentRedirection(orderSummary, {
    thankYouPageUrlSlug: navigation.THANK_YOU
  });

  const callbacks = {};
  const isPreviousIpp = cart?.order?.mobile?.existingDevice?.ippDetails;

  const existingOrder = {
    device: isPreviousIpp && cart?.order?.mobile?.existingDevice?.model
  };

  const _getPaymentOptions = (): FormattedPaymentOption[] => {
    return getPaymentOptions({
      paymentOptions,
      flow: order?.productOrder?.type,
      deliveryMethod: fulfilmentState?.delivery?.selectedDeliveryMode,
      isExistingCustomer:
        checkout?.checkoutFlow !== CHECKOUT_CONSTANTS.CHECKOUT_NEW_NEW_CUSTOMER
    });
  };

  const init = () => {
    const userInfoEmail =
      userInformation?.clientContext?.contact?.email ||
      checkout?.checkoutRetrieveContactData?.emailId;
    const retrieveContactData = checkout?.checkoutRetrieveContactData;
    const userContact = isNewNewFlow
      ? {
          firstName: retrieveContactData?.name,
          lastName: '',
          indentValue: retrieveContactData?.id,
          dateOfBirth: retrieveContactData?.birthDate,
          phone: retrieveContactData?.phone,
          email: retrieveContactData?.emailId
        }
      : getUserContactInfo(
          user.information?.clientContext?.contact,
          updatedContact
        );

    const planDescription = createDescription({
      data: selectedPlan?.data,
      sms: selectedPlan?.sms,
      talktime: selectedPlan?.talktime
    });
    const mobilePlan = cart?.order?.mobile?.plan;
    const orderSummaryData = {
      ...orderSummary?.order,
      selectedService: productOrder?.service,
      freebies: cartOrder?.freebies,
      selectedPlan: {
        name: mobilePlan?.name,
        description: planDescription,
        price: mobilePlan?.price,
        groupName: selectedPlan?.groupName
      }
    };

    const dataObject = {
      cartOrder: orderSummaryData,
      selectedProduct: product?.selectedProduct,
      orderType: productOrder?.type,
      mainLines: user?.mainLines,
      userSelectedServiceId: user?.selectedService?.serviceId,
      plans: plans,
      userProducts: user?.products,
      callbacks: callbacks,
      existingOrder: existingOrder,
      cisUser: cisUserInfo,
      hasAction: false,
      callFromOrderSummary: true
    };

    const dataModel = getShoppingCartDataModel({
      ...dataObject,
      freebiesStockData: getFreebieStockData(cartOrder?.freebies)
    });

    const isOnePass = user.information?.userDetails?.loginId;
    const needMask = user.information?.userDetails && !isOnePass;
    const promoCodeResult = getPromoResult(promoCodeInfo, orderSummary);
    dispatch({
      type: ACTION_TYPES.ORDER.SET_PRODUCTS_LIST,
      value: { productsList, isBuyingWithoutDevice }
    });
    const yuuMembership = getYuuMemberInfo(
      membership?.memberBanner,
      thirdParty?.indicator?.partnerId
    );
    const personalInfoData = getPersonalInfo({
      userContact,
      needMask,
      flow: checkout.checkoutFlow,
      isOnePass
    });
    const combinedData = {
      membershipData: cisUserInfo
        ? {}
        : {
            value: yuuMembership?.value,
            title: yuuMembership?.title,
            subTitle: yuuMembership?.description,
            note: yuuMembership?.footer,
            icon: yuuMembership?.icon,
            isComingFromApp: !!yuuMembership?.value
          },
      ...dataModel,
      productsList,
      eSimDeliveryOptions: getESimDeliveryOptions(
        isESimOrder,
        isNewNewFlow ? retrieveContactData?.emailId : userInfoEmail
      ),
      deliveryOptions: deliveryOptions
        ? { ...deliveryOptions, showChangeOption: !isNewNewFlow }
        : deliveryOptions,
      paymentOptions: _getPaymentOptions(),
      personalInfo: personalInfoData,
      billingAddress: getBillingAddressInfo(
        orderSummary.quoteData?.billingAddress,
        checkout.checkoutFlow,
        hideBillingChange
      ),
      orderSummaryData: getOrderSummaryConfigData(),
      ...promoCodeResult
    };
    setDataModel(combinedData);
  };

  const fetchContract = () => {
    if (orderSummary.quoteFetched) {
      const { barId } = getAccountBillingInfo({
        checkout,
        delivery: fulfilmentState.delivery,
        userInformation,
        productOrder
      });
      if (barId) {
        const { productOrderId } = productOrder;
        dispatch(
          orderSummaryActions.getContract({
            productOrderId,
            billingAccountId: barId
          })
        );
      } else {
        dispatch({
          type: MODULE_ACTION_TYPES.ORDER_SUMMARY.GET_CONTRACT_FAILED
        });
      }
    }
  };

  const getCustomerId = () => {
    const { customerId } = getAccountBillingInfo({
      checkout,
      delivery: fulfilmentState?.delivery,
      userInformation,
      productOrder
    });
    return customerId;
  };

  const applyPromo = (promo: string) => {
    const promoCodeOptions: PromoCodeOptions = {
      productOrderId: productOrder?.productOrderId,
      updateProducts: true,
      productOrder: productOrder,
      userInformation: userInformation,
      orderSummaryPayload: getOrderSummaryPayload(),
      customerId: getCustomerId()
    };

    // Remove Button Handling
    if (!promo || promo === PromoCodeEmpty.CLEAR) {
      dispatch(
        orderActions.addPromoCode({
          ...promoCodeOptions,
          promoString: PromoCodeEmpty.EMPTY,
          promoCheckNeeded: false
        })
      );
      dispatch(resetPromoData());
      return;
    }

    //Add Button Handling
    dispatch(
      orderActions.addPromoCode({
        ...promoCodeOptions,
        promoString: promo?.toUpperCase(),
        promoCheckNeeded: promo !== PromoCodeEmpty.EMPTY
      })
    );
  };

  const renderHeader = () => {
    return (
      <Spacing top={2}>
        <Grid noGutter>
          <Row>
            <Column xs={12} md={8} noGutter>
              <Stepper
                totalSteps={stepperTitles?.length}
                activeStep={stepperTitles?.length}
                titles={stepperTitles}
              />
            </Column>
          </Row>
        </Grid>
      </Spacing>
    );
  };

  const renderChangeContactModal = useCallback(() => {
    if (!showContactModal) {
      return null;
    }

    return (
      <ChangeContactDetails
        isOpen={showContactModal}
        closeContactModal={(callContract = false) => {
          setShowContactModal(false);
          if (callContract) {
            fetchContract();
            dispatch(getUserInformation());
          }
        }}
        personalInfo={dataModel.personalInfo}
      />
    );
  }, [dataModel?.personalInfo, showContactModal]);

  const onSectionClicked = (actionType: ActionTypes) => {
    switch (actionType) {
      case ActionTypes.CHANGE_BILLING_ADDRESS:
      case ActionTypes.CHANGE_PERSONAL_INFO: {
        window.history.go(-(checkout.stepperTitles?.length - 1 || 2));
        return;
      }
      case ActionTypes.CHANGE_STORE_SELECTION:
      case ActionTypes.CHANGE_POPSTATION_ADDRESS:
      case ActionTypes.CHANGE_DELIVERY_ADDRESS: {
        window.history.go(-1);
        return;
      }
      case ActionTypes.CHANGE_PERSONAL_INFO_EXISTING:
      case ActionTypes.CHANGE_PERSONAL_INFO_RECON: {
        setShowContactModal(true);
      }
    }
  };

  const onPlaceOrder = (paymentType, data) => {
    window.sessionStorage.setItem('flow', '');
    const membershipId =
      (dataModel.membershipData?.isComingFromApp ||
        dataModel.membershipData?.isValid) &&
      dataModel.membershipData?.value;
    const isZeroUpfront = isZeroUpfrontCharges(orderSummary?.quoteData);
    const isOnlinePayment =
      paymentType === ORDER_CONSTANTS.PAYMENT_TYPES.ONLINE;
    const { barId, customerId } = getAccountBillingInfo({
      checkout,
      delivery: fulfilmentState.delivery,
      userInformation,
      productOrder
    });
    const paymentIntentRequestData = getPaymentIntentParams({
      userInformation,
      customerId,
      contactAddress,
      quoteData: orderSummary?.quoteData,
      productOrderReferenceNumber: productOrder?.productOrderReferenceNumber
    });
    const paymentRequestData = getPaymentRequestParams({
      quoteData: orderSummary?.quoteData,
      productOrder,
      cartOrder: cart.order,
      cartItems: cart.cartOrder,
      userInformation,
      allocationStatusArray:
        fulfilmentState?.allocateOrReserve?.data?.allocationStatusX9,
      reservationStatusArray:
        fulfilmentState?.allocateOrReserve?.reserveEquipmentData
          ?.reservationStatusX9,
      customerId,
      deliveryMode: fulfilmentState.delivery?.selectedDeliveryMode,
      selectedPlan,
      selectedProduct: product.selectedProduct,
      checkout,
      billingAccountDetails,
      paymentType: isOnlinePayment ? PaymentType.ONLINE : PaymentType.OFFLINE,
      contractList: orderSummary?.contractList,
      authHeaders: auth.headers,
      merchantCode: config?.merchantId,
      checkoutBarId: barId,
      lineOfBusiness: orderSummary?.quoteData?.lineOfBusiness,
      billPayer: auth.headers[CONSTANTS.HEADERS.HTTP_BILL_PAYER],
      barId,
      storeEAppData: fulfilmentState?.delivery?.storeEAppData,
      iphone
    });

    if (!validatePaymentRequest(paymentRequestData)) {
      return dispatch({
        type: ACTION_TYPES.ORDER.VALIDATE_REQUEST_PAYMENT_FAILED
      });
    }

    const getPxDetailsData = () => {
      const pxInfo = {
        calculationId: pxAddonsCalculationId.current,
        productsList: addons?.pxAddons?.map(item => ({
          productName: item.name,
          variantName: `${item.variant.name}${
            item.variant.tagline ? ' ' + item.variant.tagline : ''
          }`
        }))
      };

      return addons?.pxAddons && pxAddonsCalculationId.current
        ? {
            pxDetails: pxInfo ? JSON.stringify(pxInfo) : ''
          }
        : {};
    };

    // clear third party indicator after placing order
    dispatch({ type: ACTION_TYPES.THIRD_PARTY.UPDATE_INDICATOR, payload: {} });
    dispatch(
      setThankYouPageData({
        hasDevice: !!selectedProduct,
        simType: order.productOrder?.sim?.selectedSimType,
        flowType: order.productOrder?.type
      })
    );
    dispatch(
      orderSummaryActions.requestPayment(
        userInformation?.clientContext?.contact?.contactId ||
          userInformation?.anonymousContactId,
        {
          membershipCode: dataModel.membershipData?.isComingFromApp
            ? thirdParty?.indicator?.partnerCode
            : CONFIGS.YUU_MEMBERSHIP_CODE,
          membershipId,
          paymentRequestData: { ...paymentRequestData, ...getPxDetailsData() },
          paymentIntentRequestData:
            isOnlinePayment && !isZeroUpfront ? paymentIntentRequestData : null,
          customerId,
          billingAccountId: barId,
          planName: selectedPlan?.planName,
          flowType: ORDER_CONSTANTS.EKYC_FLOW_TYPE[order?.productOrder?.type],
          isEkyc: isEkycFlow || changeCISMyInfoFlow
        }
      )
    );
  };

  const handleTncModal = () => {
    setTncModal(true);
  };

  const renderSkipStepModal = () => {
    const goBack = () => {
      window.history.go(-1);
    };
    return (
      <SkipStepModal
        isOpen={showMissingStepModal}
        onClose={goBack}
        onCtaClick={goBack}
      />
    );
  };

  const handleDppLink = () => {
    const url = '' + dppLink;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (
    user.isLoading ||
    orderSummary.isShowSkeletonLoader ||
    auth.isLoading ||
    !orderSummary?.quoteFetched
  ) {
    return (
      <>
        {renderHeader()}
        <SkeletonWithSideBar />
      </>
    );
  }

  if (!dataModel) return null;

  return (
    <>
      <OrderSummaryModule
        data={dataModel}
        ui={{
          Tnc: (
            <Tnc
              handleTncModal={handleTncModal}
              handleDppLink={handleDppLink}
            />
          ),
          Stepper: renderHeader()
        }}
        callbacks={{
          onSectionClicked,
          onPlaceOrder,
          applyPromo
        }}
        localisation={{}}
        configs={{
          showOutOfStock: true,
          buyflowType: ORDER_SUMMARY_CONSTANTS.MOBILE,
          membership: {
            show: isYuuEnabled
          },
          stickyBoundaryElement: '.stickyBoundary'
        }}
      />
      {tncModal ? (
        <TermsAndConditions
          isModalOpen={tncModal}
          setIsModalOpen={setTncModal}
        />
      ) : null}
      {isShowOverlayLoading && <LoadingOverlayComponent />}
      {!tabIsAmended && renderError()}
      {renderAmendedErrorPopup()}
      {renderChangeContactModal()}
      {renderSkipStepModal()}
    </>
  );
};
